module.exports = __webpack_public_path__ + "static/pic14.f4b19a95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic14.jpg
// module id = 521
// module chunks = 263791100135453